import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import SignIn from '../components/signIn'
import { checkAuth, logout } from '../business/api'
const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_FAILURE = 'AUTH_FAILURE';

const API = process.env.REACT_APP_API_END_POINT;
const initialState = { token: localStorage.getItem('token') };
function reducer(state, action) {
  switch (action.type) {
    case AUTH_FAILURE:
      return { ...state, authenticated: false };
    case AUTH_SUCCESS:
      return { ...state, authenticated: true };
    default:
      throw new Error();
  }
}

const WithAuth = (comp) => (props) => <Auth app={comp} />

const Auth = ({ app: App }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    checkLoginStatus();
  }, [])
  const checkLoginStatus = () => {
    setBusy(true)
    checkAuth()
      .then(response => {
        setBusy(false)
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return onAuthSuccess()
      })
      .then(json => console.log(`json`, json))
      .catch(error => dispatch({ type: AUTH_FAILURE }))
  }
  const onLogout = () => logout().then(onAuthFailure)
  const onAuthSuccess = () => dispatch({ type: AUTH_SUCCESS })
  const onAuthFailure = () => dispatch({ type: AUTH_FAILURE })
  return busy ? <Loader /> : (state.authenticated ? <App onLogout={onLogout} /> : <SignIn onAuthSuccess={onAuthSuccess} />)
}
const Loader = () => <div className={'preloader'}><div><CircularProgress /></div></div>

export default WithAuth